import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldType } from '../../Common/Types/Field'
import Dropdown from '../../Common/Components/Dropdown'
import i18n from '../../i18n'

const options = [
  { value: 'SNAPSHOT', label: i18n.t('campaigns:ui.Snapshot') },
  { value: 'CONTINUOUS', label: i18n.t('campaigns:ui.Continuous') },
]

const TargetDropdown = ({ value, onChange, required, error, helperText, ...other }) => {
  const { t } = useTranslation()

  return (
    <Dropdown
      label={t('common:fields.ring')}
      required={required}
      value={value}
      onChange={onChange}
      options={options}
      error={error}
      helperText={helperText}
      {...other}
    />
  )
}

TargetDropdown.defaultProps = {
  required: false,
}

TargetDropdown.propTypes = FieldType

export default TargetDropdown
